<ng-container *ngIf="patchingItemForm !== null && replacingItem !== null">
  <h3 mat-dialog-title i18n>Editing {{ replacingItem.name }}</h3>
  <mat-dialog-content>
    <form>
      <eas-editor-booking-item-name-form *ngIf="patchingItemForm.get('name')"
        [parentFormGroup]="patchingItemForm"
        [itemNameForm]="getPatchingItemFormControl('name')">
      </eas-editor-booking-item-name-form>

      <eas-editor-booking-item-booking-form *ngIf="patchingItemForm.get('canBeBooked') && patchingItemForm.get('hideSpecificBookingSettings')"
        [parentFormGroup]="patchingItemForm"
        [replacingItem]="replacingItem"
        [itemCanBeBookedForm]="getPatchingItemFormControl('canBeBooked')"
        [itemHideSpecificBookingSettingsForm]="getPatchingItemFormControl('hideSpecificBookingSettings')">
      </eas-editor-booking-item-booking-form>

      <eas-editor-booking-item-bundle-form *ngIf="patchingItemForm.get('bundle')"
        [parentFormGroup]="patchingItemForm"
        [itemBundle]="patchingItem.bundle"
        [itemBundleForm]="getPatchingItemFormControl('bundle')"
        [itemSiblings]="replacingItem.siblings">
      </eas-editor-booking-item-bundle-form>

      <ng-container *ngIf="getPatchingItemFormArray('settings')" [formGroup]="patchingItemForm">
        <ng-container formGroupName="settings">
          <eas-editor-booking-item-setting-form *ngFor="let itemSetting of patchingItem.settings; let itemSettingIndex = index"
            [itemSetting]="itemSetting"
            [parentItemSetting]="parentPatchingItem !== null ? parentPatchingItem.settings[itemSettingIndex] : null"
            [itemSettingForm]="getPatchingItemFormArrayFormGroup('settings', itemSettingIndex)">
          </eas-editor-booking-item-setting-form>
        </ng-container>
      </ng-container>

      <eas-editor-booking-item-metadata-list-form *ngIf="getPatchingItemFormArray('metadataList')"
        [parentFormGroup]="patchingItemForm"
        [itemMetadataList]="patchingItem.metadataList"
        [parentItemMetadataList]="parentPatchingItem !== null ? parentPatchingItem.metadataList : null"
        [itemMetadataListFormArray]="getPatchingItemFormArray('metadataList')"
        [newItemMetadataListFormArray]="getPatchingItemFormArray('newMetadataList')">
      </eas-editor-booking-item-metadata-list-form>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" i18n>Discard</button>
    <button mat-flat-button color="primary" [disabled]="patchingItemForm.invalid" (click)="onSubmit()" i18n>Apply</button>
  </mat-dialog-actions>
</ng-container>
